import { InjectionToken } from '@angular/core';

export const EnvironmentObject = new InjectionToken<any>(null);
